import { defineMessages } from "react-intl";

export const messages = defineMessages({
  lookupFailed: {
    id: "ads_manager.account_logo.error.lookup_failed",
    defaultMessage:
      "We couldn't find a supported logo or favicon at that URL. Try a different website URL or upload a PNG, JPG, GIF, or WEBP logo.",
    description: "Error shown when an account logo cannot be found at a supplied URL.",
  },
  invalidUrl: {
    id: "ads_manager.account_logo.error.invalid_url",
    defaultMessage: "Enter a valid image or website URL.",
    description: "Error shown when an account-logo URL is invalid.",
  },
  dimensionsTooSmall: {
    id: "ads_manager.account_logo.error.dimensions_too_small",
    defaultMessage:
      "Logo must be at least {minimumWidth}x{minimumHeight} pixels. Selected image is {width}x{height} pixels.",
    description: "Error shown when an uploaded account logo is too small.",
  },
  invalidImageFile: {
    id: "ads_manager.account_logo.error.invalid_image_file",
    defaultMessage: "Logo must be a valid image file.",
    description: "Error shown when an uploaded account logo cannot be read as an image.",
  },
});
